import { render, staticRenderFns } from "./newchongqing404.vue?vue&type=template&id=4b81be5e&scoped=true&"
import script from "./newchongqing404.vue?vue&type=script&lang=ts&"
export * from "./newchongqing404.vue?vue&type=script&lang=ts&"
import style0 from "./newchongqing404.vue?vue&type=style&index=0&id=4b81be5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81be5e",
  null
  
)

export default component.exports